export default "__VITE_ASSET__D5Gn5bsU__"